import Spin from 'antd/lib/spin';
import { toolbarOptions3 } from 'assets/sheets/images';
import Button from 'components/Button';
import Editor from 'components/Editor/Editor';
import ModalCommon from 'components/Input/ModalCommon';
import { NO_INTERNET } from 'components/messageError';
import { useCallback, useEffect, useRef, useState } from 'react';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import { toast } from 'sonner';

const NotePopup = ({ isOpen, onCancel, noteId, onSuccess }) => {
  const notesRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [form, setForm] = useState({
    notes: '',
  });

  const handleAfterOpen = useCallback(() => {
    const modalBody = document.querySelector('.ant-modal-body');
    if (modalBody) {
      modalBody.scrollTop = 0;
    }
  }, []);

  const getInfoUser = () => {
    setLoading(true);
    CourseScheduleRegistationServices.getInfo(noteId)
      .then((res) => {
        setForm({
          notes: res.data.notes
        });
        setResetKey((k) => k + 1); // This will trigger reinit in Editor
      })
      .catch((err) => toast.error(err?.message || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isOpen && noteId) {
      getInfoUser();
    } else if (!isOpen) {
      // Clear form when modal closes
      setForm({ notes: '' });
    }
  }, [isOpen, noteId]);

  const updateNote = () => {
    setLoading(true);
    const cleanedNotes = (form.notes);

    CourseScheduleRegistationServices.updateCourseRegistration(noteId, {
      notes: cleanedNotes,
    })
      .then((res) => {
        if (res.data) {
          onSuccess(); // This should trigger parent to refetch data
          onCancel();
        }
      })
      .catch((err) => {
        toast.error(err.message || NO_INTERNET);
      })
      .finally(() => setLoading(false));
  };

  const handleChangeData = ({ label, value }) => {
    setForm({
      ...form,
      [label]: value,
    });
  };

  const handleSave = () => {
    updateNote();
  };

  const handleCancel = () => {
    notesRef.current?.reset();
    onCancel();
  };

  return (
    <ModalCommon
      width={600}
      onAfterOpen={handleAfterOpen}
      title={'備考'}
      loading={loading}
      open={isOpen}
      onCancel={handleCancel}
      heightHeader={56}
      footer={
        <div className="flex h-max justify-end gap-4 border-t border-[#e9e9e9] pt-4">
          <Button
            btnType="back"
            onClick={handleCancel}
            fontSize={14}
            width={120}
            height={40}
          >
            キャンセル
          </Button>
          <Button
            btnType="primary"
            onClick={handleSave}
            fontSize={14}
            width={120}
            height={40}
          >
            <p style={{ letterSpacing: '0', fontSize: '14px' }}>保存</p>
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <Editor
          ref={notesRef}
          label={'備考'}
          title="notes"
          alignLabel="center"
          widthLabel={142}
          options={[toolbarOptions3]}
          widthEditor={399}
          heightEditor={260}
          value={form.notes ?? ''}
          resetKey={resetKey}
          onChange={handleChangeData}
        />
      </Spin>
    </ModalCommon>
  );
};

export default NotePopup;
